import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import { NavLink } from "react-router-dom";
import ServiceSide from "./ServiceSide";

function Services() {
  return (
    <>
      <SEO
        title="Best Software Maintenance Services in Hyderabad - Moironix"
        description="Keeping Your Software Up-To-Date, Secure, and Running at Peak Performance — Moironix Soft Solutions Has You Covered"
        keywords="Software Maintenance Services, Application Maintenance and Support, Legacy Software Modernization, Software Support and Maintenance, Bug Fixing and Software Updates, Software Lifecycle Management, Software Patch Management, System Performance Optimization, Custom Software Development, Software Development Services, Software Outsourcing Company, Software Engineer Consulting, Software Engineering Consultants, Software Development Outsourcing Company, Software Maintenance Services in Hyderabad, It Support Hyderabad, Application Support Services Hyderabad, Software Companies near Me, Hire Software Maintenance Company, Best Software Support Services, Affordable Software Maintenance Plans, Enterprise Application Maintenance, Custom Software Maintenance for Healthcare, Fintech Application Support Services, SaaS Application Maintenance, Cloud-Based Software Maintenance Solutions"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Software Maintenance & Support</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">
                      Software Maintenance & Support
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="site-main">
          <div className="prt-row sidebar prt-sidebar-left clearfix">
            <div className="container">
              <div className="row">
                <div className="widget-area sidebar-left prtcol-bgcolor-yes prt-bg prt-left-span bg-base-grey">
                  <ServiceSide />
                </div>
                <div className="col-lg-8 content-area">
                  <div className="prt-service-single-content-area">
                    <div className="prt_fatured_image-wrapper mb-40 res-575-mb-20">
                      <img
                        width={859}
                        height={440}
                        className="img-fluid"
                        src="images/d6.jpeg"
                        alt="services-1"
                      />
                    </div>
                    <div className="prt-service-description">
                      <h3>Software Maintenance & Support</h3>
                      <p>
                        we specialize in delivering innovative and robust
                        Software Maintenance & Support services that empower
                        businesses to achieve their goals with cutting-edge
                        technology. Our team of skilled developers, designers,
                        and project managers work together to create custom
                        applications that meet your specific needs and drive
                        your digital transformation.
                      </p>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <ul className="service-detail-list">
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Custom Software Development
                              </div>
                            </li>
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Web Software Maintenance & Support
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Mobile Software Maintenance & Support
                                </div>
                              </li>
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Enterprise Application Solutions
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Support and Maintenance
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Footer />
    </>
  );
}

export default Services;
